class Rules {

    constructor(input, attributes = []) {
        this.input = input;
        this.attributes = attributes;
    }

    item() {
        switch(this.input.parents.length) {
            case 0:
                return this.input.form.fields[this.input.field];
            case 1:
                return this.input.form.fields[this.input.parents[0]][this.input.field];
            case 2:
                return this.input.form.fields[this.input.parents[0]][this.input.parents[1]][this.input.field];
            case 3:
                return this.input.form.fields[this.input.parents[0]][this.input.parents[1]][this.input.parents[3]][this.input.field];
        }
        throw new Error("Input array is deeper than 3 levels");
    }

    length() {
        if (this.item() === null) {
            return 0;
        }
        return this.item().toString().length;
    }

    required() {
        return (
            this.item() !== undefined &&
            this.length() > 0
        );
    }

    min() {
        return this.length() >= this.attributes[0];
    }

    max() {
        return this.length() <= this.attributes[0];
    }

    email() {
        const pattern = /^[a-zA-Z0-9._\-]+@[a-zA-Z0-9]+([.\-]?[a-zA-Z0-9]+)?([\.]{1}[a-zA-Z]{2,4}){1,4}$/;

        return pattern.test(this.item());
    }

    forgiving_email() {
        const pattern = /[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+.[a-zA-Z]{2,4}/;

        return pattern.test(this.item());
    }

    password() {
        const pattern = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;
        return pattern.test(this.item());
    }

    confirmed() {

    }

    checked() {
        return this.item() === true;
    }

}

export default Rules;